import { getSpecificWorkroom } from 'Frontend/scripts/services/workrooms.service'
import { FunctionComponent, useEffect, useState } from 'react'
import Dialog from 'Features/Dialog/Dialog'
import { getAntiforgeryToken } from 'Frontend/scripts/services/general.service'
import { IAntiforgeryToken } from 'Frontend/scripts/models/general.model'
import { Button } from 'react-bootstrap'

import {
  deleteWorkroom,
  isCurrentUserMember,
  joinWorkroom,
  leaveWorkroom,
} from 'Frontend/scripts/services/workrooms.service'
import EditWorkroom from './EditWorkroom'
import { IWorkroomUserPermissions } from 'Frontend/scripts/models/workrooms.model'
import { useTranslation } from 'react-i18next'

interface WorkroomDescriptionProps {
  id: number
  workroomListingUrl: string
  permissions: IWorkroomUserPermissions | undefined
  callback: (__name: string) => void | null
}

const WorkroomDescription: FunctionComponent<WorkroomDescriptionProps> = ({
  id,
  workroomListingUrl,
  permissions,
  callback,
}) => {
  const [description, setDescription] = useState<string>('')
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState<boolean>(false)
  const [isMember, setIsMember] = useState<boolean>(false)
  const [showEdit, setShowEdit] = useState<boolean>(false)
  const { t } = useTranslation()

  const deleteThisWorkroom = () => {
    deleteWorkroom(id).then(() => {
      setIsDeleteDialogOpen(false)
      if (workroomListingUrl != null) {
        window.location.href = workroomListingUrl
      }
    })
  }

  const userJoinWorkroom = (workRoomId: number) => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      joinWorkroom(token.csrfToken, workRoomId).then(() => {
        setIsMember(true)
      })
    })
  }

  const userLeaveWorkroom = (workRoomId: number) => {
    getAntiforgeryToken().then((token: IAntiforgeryToken) => {
      leaveWorkroom(token.csrfToken, workRoomId).then(() => {
        setIsMember(false)
      })
    })
  }

  useEffect(() => {
    getSpecificWorkroom(id).then((workroom) => {
      setDescription(workroom.description)
    })

    isCurrentUserMember(id).then((isMember) => {
      setIsMember(isMember)
    })
  }, [])

  const createMarkup = (body: string) => {
    return { __html: body }
  }

  return (
    <>
      {showEdit ? (
        <EditWorkroom
          id={id}
          permissionToChangeWorkroomVisibility={permissions?.changeWorkroomVisibility as boolean}
          callback={(name, description) => {
            setShowEdit(false)
            {
              name && callback(name)
              description && setDescription(description)
            }
          }}
        />
      ) : (
        <>
          <div className="workrooms__description" dangerouslySetInnerHTML={createMarkup(description)}></div>

          <div className="d-flex gap-2 mt-4 justify-content-end">
            {isMember ? (
              <Button variant="dark" className="flex-shrink-0" onClick={() => userLeaveWorkroom(id)}>
                {t('leave')}
              </Button>
            ) : (
              <Button variant="secondary" className="flex-shrink-0" onClick={() => userJoinWorkroom(id)}>
                {t('join')}
              </Button>
            )}
            {permissions?.updateWorkroom && (
              <Button
                variant="outline-secondary"
                className="gap-2 livstecknet-thread__edit-question"
                onClick={() => setShowEdit(!showEdit)}
              >
                <span className="fa fa-pencil"></span>
                {t('edit')}
              </Button>
            )}
            {permissions?.deleteWorkroom && (
              <>
                <Button
                  variant="dark"
                  className="gap-2 livstecknet-thread__edit-question"
                  onClick={() => setIsDeleteDialogOpen(true)}
                >
                  <span className="fa fa-trash-o"></span>
                  {t('delete')}
                </Button>
                <Dialog
                  isOpen={isDeleteDialogOpen}
                  verificationText={t('verification-delete-workroom')}
                  submitText={t('yes-delete-workroom')}
                  abortText={t('abort')}
                  buttonVariant="dark"
                  callbackSubmit={() => deleteThisWorkroom()}
                  callbackClose={() => setIsDeleteDialogOpen(false)}
                />
              </>
            )}
          </div>
        </>
      )}
    </>
  )
}
export default WorkroomDescription
